import { httpClient } from "../http/httpClient"
import type { ProductImageVariant } from "./uploadProductImage"

export async function removeProductImage(
  type: string,
  path: string,
  variant: ProductImageVariant = 'image',
) {
  const { data } = await httpClient.delete<{ success: boolean }>(
    `/config/product/${type}/image`,
    { data: { path }, params: { variant } },
  )
  return data
}